export default __webpack_public_path__ + "static/media/Icon_record_cancel.9d6e1b83.svg";